"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmNew = exports.useConfirm = void 0;
var react_1 = require("react");
var ConfirmationModalContext_1 = __importDefault(require("./ConfirmationModalContext"));
var useConfirm = function () {
    var setConfirmModalState = (0, react_1.useContext)(ConfirmationModalContext_1.default);
    return function (heading, confirmText, buttonType, buttonLabel, noCancel) { return new Promise(function (resolve) {
        var onClose = function () {
            setConfirmModalState === null || setConfirmModalState === void 0 ? void 0 : setConfirmModalState(null);
            resolve(null);
        };
        var onClick = function () {
            setConfirmModalState === null || setConfirmModalState === void 0 ? void 0 : setConfirmModalState(null);
            resolve(true);
        };
        setConfirmModalState === null || setConfirmModalState === void 0 ? void 0 : setConfirmModalState({
            heading: heading,
            confirmText: confirmText,
            buttonType: buttonType,
            buttonLabel: buttonLabel,
            onClose: onClose,
            onClick: onClick,
            noCancel: noCancel,
        });
    }); };
};
exports.useConfirm = useConfirm;
var useConfirmNew = function () {
    var setConfirmModalState = (0, react_1.useContext)(ConfirmationModalContext_1.default);
    return function (heading, confirmPromptConfig) { return new Promise(function (resolve) {
        var onClose = function () {
            setConfirmModalState === null || setConfirmModalState === void 0 ? void 0 : setConfirmModalState(null);
            resolve(null);
        };
        var onClick = function () {
            setConfirmModalState === null || setConfirmModalState === void 0 ? void 0 : setConfirmModalState(null);
            resolve(true);
        };
        setConfirmModalState === null || setConfirmModalState === void 0 ? void 0 : setConfirmModalState(__assign({ heading: heading, onClose: onClose, onClick: onClick }, confirmPromptConfig));
    }); };
};
exports.useConfirmNew = useConfirmNew;
